<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="举报商品" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="div"  v-if="informList && informList.length">
                <div class="div inform-item"  v-for="(item, index) in informList" :key="index">
                	<div class="head">
                		<div class="type">{{item.informsubject_type_name}}</div>
                		<div class="time">{{ $moment.unix(item.inform_datetime).format('YYYY年MM月DD日') }}</div>
                	</div>
                	<div class="goods_info" @click="$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': item.inform_goods_id } })" >
                		<div class="image-wrapper">
                			<img class="img" :src="item.inform_goods_image_url"/>
                		</div>
                		<div class="p-info">
                			<div class="goods_name">{{item.inform_goods_name}}</div>
                			<div class="goods_price">￥{{item.inform_goods_price}}</div>
                		</div>
                	</div>
                	<div class="div inform-info">
                		<div class="inform_content"><span>举报内容：</span>{{item.inform_content}}</div>
                		<div class="inform_handle_message" v-if="item.inform_handle_message"><span>平台回复：</span>{{item.inform_handle_message}}</div>
                	</div>
                    <div class="div inform-btn">
                        <div class="div btn-wrapper" v-if="item.inform_state=='1'"><div class="btn div common-btn ds-button-small"  @click="cancelInform(item.inform_id)">取消</div></div>
                        <div class="div btn-wrapper"><div class="btn div common-btn default ds-button-small" @click="goNavigate('/pages/member/inform/InformForm',{inform_id:item.inform_id})">查看</div></div>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="informList && !informList.length"></empty-record>
        </div>
    </div>
</template>

<script>
import { Indicator, MessageBox, Toast } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getInformList, cancelInform } from '../../../api/memberInform'
export default {
  name: 'BillList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      informList: false, // 商品列表
    }
  },
  methods: {
    cancelInform (order_id) {
      MessageBox.confirm('你确定要取消吗？').then(action => {
        cancelInform(order_id).then(res => {
          Toast(res.message)
          this.$router.go(0)
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    getInformList (ispush) {
      Indicator.open()
      let params = this.params
      getInformList(params).then(res => {
        Indicator.close()
        if (res) {
          if (ispush && this.informList) {
            this.informList = this.informList.concat(res.result.inform_list)
          } else {
            this.informList = res.result.inform_list
          }
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getInformList(true)
      }
    }

  }
}
</script>

<style scoped lang="scss">
.inform-item{
	background:#fff;
	border-bottom:1px solid #e1e1e1;
	margin-top: $modelSpace;
	border-radius: .5rem;
	padding: 0 $pageSpace;
	box-sizing: border-box;
	.head{
		padding: .3rem 0;
		display: flex;
		align-items: center;
		.type{
			font-size: .8rem;
			color: #333;
		}
		.time{
			font-size: .6rem;
			color: #999;
			margin-left: auto;
		}
	}
	.goods_info{
		display: flex;
		box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);
		.image-wrapper{
			width: 4rem;
			height: 4rem;
			flex: 0 0 4rem;
			border-radius: .5rem;
			overflow: hidden;
			img{
				width: 4rem;
				height: 4rem;
			}
		}
		.p-info{
			margin-left: .5rem;
			.goods_name{
				color: #333;
				font-size: .7rem; 
				line-height: .8rem;
				height: 1.6rem;
				margin-top: .4rem;
				overflow: hidden;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				padding: 0 .3rem;
				box-sizing: border-box;
			}
			.goods_price{
				color: $primaryColor;
				font-size: .8rem;
				margin-top: 1rem;
			}
		}
	}
	.inform-info{
		padding: $modelSpace 0;
		.inform_content{
			font-size: .7rem;
			color: #666;
			text{
				color: #333;
			}
		}
		.inform_handle_message{
			font-size: .7rem;
			color: #666;
			text{
				color: #333;
			}
		}
	}
	.inform-btn{
		padding:.5rem;
		border-top:1px solid #e4e4e4;
		display: flex;
		justify-content: flex-end;
		.btn-wrapper{
			margin-left:.5rem
		}
		.buyer-info{
			flex:1;
			font-size:$subFontSize;
			line-height:1.4rem
		}
	}
}
</style>
